<template>
    <div class="page">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Fale conosco</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content pt-70">

            <div class="container hidden-xs hidden-md">
                <h2>Fale conosco</h2>
            </div>

            <div class="container">
                <div class="title-bar">
                    <h5 class="dz-title" style="width: 100%;">
                        <i class="las la-comment"></i>
                        Envie uma mensagem abaixo
                    </h5>
                </div>
                <form  method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list mt-0 no-hairlines-ios">
                        <ul class="row">
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.nome" placeholder="Seu nome" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                  
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">E-mail <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="email" v-model="form.email" placeholder="Seu e-mail" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Telefone <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva seu telefone" autocomplete="new-password" v-model="form.telefone" />
                                    </div>
                                </div>
                            </li> 
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Mensagem <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <textarea class="form-control" placeholder="Escreva sua mensagem aqui..." autocomplete="new-password" v-model="form.mensagem"></textarea>
                                    </div>
                                </div>
                            </li>                                                                                                                                                                                           
                        </ul>                                  

                    </div>
                    <div class="clearfix container">
                        <button type="submit" class=" button-large button button-fill">
                            
                            Enviar mensagem
                        </button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'

export default {
    name: 'Conta',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "telefone":         self.$root.user.telefone,
                "mensagem":         ""
               
            }              
        }
    },  
    methods: {      
        submit: function(e) {
            var self            = this;
            console.log("submit", self.form);
            e.preventDefault();
            loading.show();
            
            axios.post("api/contato.php", self.form)
            .then(response => {
                console.log("ok", response.data.result)

                $(".page-content")[0].scrollTo({
                    top: 5
                });                                             
                loading.hide();
                self.$root.getUser();
                alert(response.data.message);
                // self.$root.setUser(response.data.result);

            })
            .catch(error => {
                loading.hide();
                
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    },    
    mounted: function() {
        var self = this;
        console.log("Conta", self.$root.user)
        self.$root.getUser().finally(function() {

            loading.hide();
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/Contato.vue